import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { canDeactivateGuard } from './core/guards/can-deactivate.guard';
import { LayoutComponent } from './layout/layout.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    // Do not redirect to not-found, as this will cause problems with login
    path: '',
    component: LayoutComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'admin/standardsektioner',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/admin/standard-sektioner/standard-sektioner.component').then(
            (m) => m.StandardSektionerComponent,
          ),
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: 'admin/standardsektion/:id',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/admin/standard-sektion/standard-sektion.component').then(
            (m) => m.StandardSektionComponent,
          ),
        canDeactivate: [canDeactivateGuard],
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: 'ansokningsomgang/:diarienummer',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/ansokningsomgang/ansokningsomgang.component').then(
            (m) => m.AnsokningsomgangComponent,
          ),
        canDeactivate: [canDeactivateGuard],
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: 'error',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: 'not-found',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
